import FooterComponent from "../components/FooterComponent";
import HeaderComponent from "../components/HeaderComponent";
import LandingComponent from "../components/LandingComponent";
import UserReviewComponent from "../components/UserReviewComponent";
import ConsultancyServicesComponent from "../components/ConsultancyServicesComponent";
import PartnershipComponent from "../components/PartnerComponenet";
import SubscriptionComponent from "../components/SubscriptionComponent";

function App() {
  return (
    <main className="bg-white">
      <HeaderComponent/>
      <LandingComponent/>
      <SubscriptionComponent/>
      <ConsultancyServicesComponent/>
      <UserReviewComponent/>
      <PartnershipComponent/>
      <FooterComponent/>
    </main>
  );
}

export default App;
